export enum AssetFamilyTypeId {
  BatteryBankFlooded = '9151834e-4887-4d33-baca-7a36bf1971da',
  BatteryBankLFP = 'fa075e68-b2ad-4ef7-8904-d66497219f81',
  BatteryBankNMC = '08a77429-0557-4194-9f30-abad9fa760bb',
  BatteryBankVRLA = '2ff7b65d-a461-4387-bb9a-6fd6d7a5ad59',
  Biogas = '8c14a9f2-51c3-4b21-9d2c-a4c46683c9e6',
  CommercialEnergyConsumer = '73663061-f1fd-450d-96cb-8ae5cd996b26',
  FireAlarmSystem = 'e4ac1065-bc82-4092-996e-d73a5895e41b',
  Generator = 'c2197459-79dc-4a6f-ade5-d07185ace07b',
  Hydro = 'e69cda0b-7c30-4557-9cc8-46512ef7cd91',
  IndustrialEnergyConsumer = 'd772ee16-69d5-46a0-9ddd-1a19d41efe50',
  MixedEnergyConsumer = 'a3c007d9-a4e5-40b6-a89c-4656c2361d9f',
  PowerGrid = '9daacd5c-6fb3-4cd3-b022-62b87b8b0836',
  ResidentialEnergyConsumer = 'daa10da5-737c-40d6-a144-58a873d99297',
  SiteNetConsumption = '3b2f1e4d-2c1b-4a5a-8d7e-9f0a1b2c3d4e',
  SiteTotalConsumption = '5f4e1c3e-3d3e-4e2f-9b4f-8c9e7e2a6d4f',
  SolarPv = 'ca14c4af-afa3-4c67-807a-d5c091239b3b',
  Wind = 'b2f25f97-d654-4a6e-b3a9-082e894c16c5',
}
